import type { Dayjs } from "dayjs";
import type { FC } from "react";
import { useState } from "react";
import { Box, IconButton, List, ListItem, ListItemText, Stack } from "@mui/material";
import { copyToClipboard } from "../../misc/copyToClipboard";
import { CopyAll as CopyIcon, Delete as DeleteIcon } from "@mui/icons-material";

const dateFormat = "DD-MM-YYYY";

export interface Note {
  readonly text: string;
  readonly date: Dayjs;
  readonly author: string;
  readonly type?: string;
}

export interface Props {
  readonly values: Note[];
  readonly onRemove?: (index: number, note: Note) => void | Promise<void>;
}

export const CustomerNotesList: FC<Props> = ({ values, onRemove }) => {
  const [expanded, setExpanded] = useState<number | null>(null);
  return (
    <List>
      {values.map((value, idx) => (
        <ListItem
          key={idx}
          onClick={() => setExpanded(expanded === idx ? null : idx)}
          secondaryAction={
            <>
              <IconButton title="Kopiuj tekst" onClick={() => copyToClipboard(value.text)}>
                <CopyIcon />
              </IconButton>
              {onRemove && (
                <IconButton onClick={() => onRemove(idx, value)} title="Usuń wiersz">
                  <DeleteIcon />
                </IconButton>
              )}
            </>
          }
          data-testid="note-stamped-list-item"
        >
          <ListItemText secondary={expanded === idx ? value.author : undefined}>
            <Stack direction="row" spacing={1}>
              <Box
                sx={{
                  flexBasis: "120px",
                  flexGrow: 0,
                  flexShrink: 0,
                }}
              >
                {value.date.format(dateFormat)}
              </Box>
              <Box
                sx={{
                  flexBasis: "150px",
                  flexShrink: 0,
                }}
              >
                {value.type}
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                }}
              >
                {value.text}
              </Box>
            </Stack>
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default CustomerNotesList;
